import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { NotificationServiceImpl } from "../../../services/NotificationServiceImpl";
import { DEFAULT_OFFSET, RECORDS_PER_PAGE } from "../../../domain/constants";
import NotificationList from "./NotificationList";
import { useSelector } from "react-redux";
import {
    selectReadNotifications,
    selectUnreadNotifications,
    setReadCollectionPage,
    setUnReadCollectionPage,
} from "../../../slices/notifications-slice";
import { Link } from "react-router-dom";
import InterestingVacancies from "../../resources/components/work-components/InterestingVacancies";

const NotificationsPage: FC = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    const readNotifications = useSelector(selectReadNotifications);
    const unreadNotifications = useSelector(selectUnreadNotifications);

    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const uploadNotifications = async (read: boolean) => {
        const currentPage = (read ? readNotifications.page : unreadNotifications.page) + 1;
        const result = await dispatch(
            NotificationServiceImpl.getNotificationsThunk({
                page: currentPage,
                limit: RECORDS_PER_PAGE,
                offset: DEFAULT_OFFSET,
                read,
            })
        );
        setIsLoaded(result.meta.requestStatus === "fulfilled");
        dispatch(read ? setReadCollectionPage(currentPage) : setUnReadCollectionPage(currentPage));
    };

    const uploadReadNotificationsCallback = useCallback(async () => {
        uploadNotifications(true);
    }, [readNotifications.page]);

    const uploadUnreadNotificationsCallback = useCallback(async () => {
        uploadNotifications(false);
    }, [unreadNotifications.page]);

    const isReadNotifications = isLoaded ? readNotifications.totalRows > 0 : true;
    const isUnreadNotifications = isLoaded ? unreadNotifications.totalRows > 0 : true;

    return (
        <div className="mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] mb-[80px] dmax2:mb-[60px]">
            <h1 className="H32B dmax2:H24B text-textWhite mb-9 dmax2:mb-6 dmin2:mt-5">{t("notifications.title")}</h1>
            <div className="flex flex-col dmin2:max-w-[845px] dmax2:w-full">
                {isUnreadNotifications && (
                    <div className="flex flex-col">
                        <div className="H14 text-textWhite flex items-center bg-primaryBlue rounded-[30px] w-fit h-[30px] px-[30px] dmax2:px-4 mb-7 dmax2:mb-4">
                            {t("notifications.newMessage", { notificationsCount: unreadNotifications.totalRows })}
                        </div>
                        <NotificationList
                            uploadNotificationsCallback={uploadUnreadNotificationsCallback}
                            notifications={unreadNotifications}
                        />
                    </div>
                )}
                {isReadNotifications && (
                    <div className="flex flex-col">
                        {/* <p className="H24 dmax2:H20 text-textFaded text-center mt-5 dmax2:">
                        {t("userProfile.emptyWorks")}
                    </p> */}
                        <div className="H14 text-textWhite flex items-center bg-[rgba(255,255,255,0.1)] rounded-[30px] w-fit h-[30px] px-[30px] dmax2:px-4 mb-7 dmax2:mb-4">
                            {t("notifications.viewedMessage", { notificationsCount: readNotifications.totalRows })}
                        </div>
                        <NotificationList
                            uploadNotificationsCallback={uploadReadNotificationsCallback}
                            notifications={readNotifications}
                        />
                    </div>
                )}
            </div>
            {!isUnreadNotifications && !isReadNotifications && (
                <div className="relative flex flex-col items-center w-full mb-[60px] dmax2:mb-[100px]">
                    <p className="H24 dmax2:H20 text-textFaded">{t("userProfile.emptyWorks")}</p>
                    <Link
                        to="/create-work"
                        className="dmin2:H16 td2:H14 tmax1:H12 text-textWhite bg-primaryBlue hover:bg-primaryBlueFocused tmax1:w-[187px] td2:w-[198px] dmin2:h-[50px] td2:h-[40px] tmax1:h-[37px] mt-9 dmax2:mt-6 rounded-xl dmax2:rounded-lg flex justify-center items-center px-6 cursor-pointer transition-all duration-300"
                    >
                        <div className="mb-[2px]">{t("userProfile.firstWorkButton")}</div>
                    </Link>
                </div>
            )}
            <InterestingVacancies />
        </div>
    );
};

export default NotificationsPage;
